import templateUrl from "emun.invoice/credit-request/credit-request-details-actions.htm";

export default () => ({ templateUrl });
